import { Theme } from '@mui/material';

import { createStyles, makeStyles } from '@mui/styles';

export default makeStyles((theme: Theme) =>
  createStyles({
    closeIcon: {
      // color: theme.palette.text.hint,

    },
    title: {
      color: '#474747',
      fontsize: '1.3rem',
    },
  }),
);
